// extracted by mini-css-extract-plugin
module.exports = {"topTitle":"style_topTitle__RQHI7"};